import { HpDispatchFunction, HpViewportState } from '../types';

export function viewportChangedAction(payload: HpViewportState) {
  return (dispatch: HpDispatchFunction<HpViewportState>): void => {
    dispatch({ type: 'VIEWPORT_CHANGED', payload });
  };
}
